import React from 'react';
import glamorous from 'glamorous';

import { defaultProps, propTypes } from './types';
import * as styles from './styles';

const Container = glamorous.div(styles.Container);
const Placeholder = glamorous.div(styles.Placeholder);
const LeftButton = glamorous.div(styles.LeftButton);
const RightButton = glamorous.div(styles.RightButton);
const RightIcon = glamorous.div(styles.RightIcon);
const LeftIcon = glamorous.div(styles.LeftIcon);
const Input = glamorous.input(styles.Input);

class TextField extends React.PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  state = {
    focused: this.props.focused,
    value: this.props.value,
  };

  get shouldRenderPlaceholder() {
    const { value } = this.state;

    const hasValue = !!value && !!value.length;
    const hasLabel = !!this.props.label;
    const hasPlaceholder = !!this.props.placeholder;

    return (hasLabel || hasPlaceholder) && !hasValue;
  }

  setFocused = focused => this.setState({ focused });

  handleChange = (e) => {
    if (this.props.onChange) {
      this.props.onChange(e);
    } else {
      this.setState({ value: e.target.value });
    }
  };

  handleBlur = (e) => {
    if (!this.props.focused) {
      this.setFocused(false);
    }

    this.props.onBlur(e);
  };

  handleFocus = (e) => {
    this.setFocused(true);
    this.props.onFocus(e);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }

    if (nextProps.focused !== this.state.focused) {
      this.setState({ focused: nextProps.focused });
    }
  }

  render () {
    const {
      label,
      style,
      placeholder,
      innerRef,
      ...rest
    } = this.props;

    const {
      focused,
      value,
    } = this.state;

    return (
      <Container
        className="TextFieldContainer"
        {...rest}
        focused={focused}
        glamStyle={style}
      >
        <Placeholder
          className="TextFieldPlaceholder"
          {...rest}
          isVisible={this.shouldRenderPlaceholder}
        >
          {label || placeholder}
        </Placeholder>

        {!!this.props.leftButton && (
          <LeftButton {...rest} focused={focused}>
            {this.props.leftButton}
          </LeftButton>
        )}

        {!!this.props.leftIcon && (
          <LeftIcon {...rest} focused={focused}>
            {this.props.leftIcon}
          </LeftIcon>
        )}

        <Input
          className="TextField"
          {...rest}
          type="text"
          value={this.props.onChange ? this.props.value : value}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          innerRef={innerRef}
        />

        {!!this.props.rightButton && (
          <RightButton {...rest} focused={focused}>
            {this.props.rightButton}
          </RightButton>
        )}

        {!!this.props.rightIcon && (
          <RightIcon {...rest} focused={focused}>
            {this.props.rightIcon}
          </RightIcon>
        )}
      </Container>
    );
  }
}

export default TextField;




// WEBPACK FOOTER //
// ./src/components/ui/TextField/TextField.js